import React from "react";
import styled from "styled-components";
import {Button} from "@unibuddy/patron";
import {useTranslation} from "@unibuddy/intl";
import {INTL_COOKIE_SETTINGS} from "../../../../translations/common";
import {IntlNamespaces} from "../../../../translations/types";

declare global {
    interface Window {
        OneTrust: {
            ToggleInfoDisplay: () => void;
        };
    }
}

const StyledButton = styled(Button)`
    color: ${({theme}) => theme?.colors?.universityColor || theme?.colors?.blue800};
    font-family: Nunito;
`;

export function CookieSettings() {
    const isPwa = window.location.pathname.includes("/pwa/");
    const {t} = useTranslation(IntlNamespaces.COMMON);

    if (!isPwa) {
        return null;
    }

    return (
        <StyledButton
            link
            aria-label={t(INTL_COOKIE_SETTINGS.key, INTL_COOKIE_SETTINGS.defaultValue)}
            onClick={() => {
                window.OneTrust.ToggleInfoDisplay();
            }}
        >
            {`${t(INTL_COOKIE_SETTINGS.key, INTL_COOKIE_SETTINGS.defaultValue)}`}
        </StyledButton>
    );
}
